<template>
  <div class="honorRollModule">
    <aside
      :style="{
        background: `linear-gradient(180deg, ${honorRollConfig.badgeBgGradientTop}, ${honorRollConfig.badgeBgGradientBottom})`,
      }"
    >
      <div
        :style="{
          background: `linear-gradient(180deg, ${honorRollConfig.badgeStripeGradientTop}, ${honorRollConfig.badgeStripeGradientBottom})`,
        }"
      ></div>
      <div :class="[getPlaceClass(honorData.segment_icon)]">
        <img
          :class="['segment_id' + honorData.segment_id]"
          :src="honorData.segment_icon"
        />
        <span>{{ honorData.segment_name }}段位</span>
        <label v-if="honorData.segment_id < 42">{{
          honorData.segment_level
        }}</label>
      </div>
      <div
        :style="{
          background: `linear-gradient(180deg, ${honorRollConfig.badgeStripeGradientTop}, ${honorRollConfig.badgeStripeGradientBottom})`,
        }"
      ></div>
    </aside>
    <main>
      <div :id="'guangrongbang' + numbers">
        <share-btn
          @shareClick="shareClick"
          title="查看海报"
          :isRightBtn="true"
          :isHonorRoll="1"
          :btnColor="homeConfig.rewardBtnColor"
        ></share-btn>
      </div>
      <dl>
        <dt>
          {{ honorData.real_name }}
        </dt>
        <dd>{{ honorData.created_at }}获得</dd>
      </dl>
    </main>
  </div>
</template>

<script>
/** 段位 id 用于区分段位等级
 * 23 3 热血黑铁
 * 24 2热血黑铁
 * 25 1热血黑铁
 * 26 3朝气白银
 * 27 2 朝气白银
 * 28 1朝气白银
 * 29 4 无畏黄金
 * 30 3 无畏黄金
 * 31 2 无畏黄金
 * 32 1无畏黄金
 * 33 4 耀世铂金
 * 34 3 耀世铂金
 * 35 2耀世铂金
 * 36 1耀世铂金
 * 37 5璀璨钻石
 * 38 4 璀璨钻石
 * 39 3璀璨钻石
 * 40 2璀璨钻石
 * 41 1璀璨钻石
 * 42 0超凡王者
 * 43 0至尊王者
 * 44 0傲世王者
 */
import normalModule from "./normalModule.vue";
import shareBtn from "@views/WinterGame/components/shareBtn.vue";

import placeImage1 from "../../../assets/images/winterGame/place/place_1.png";
import placeImage2 from "../../../assets/images/winterGame/place/place_2.png";
import placeImage3 from "../../../assets/images/winterGame/place/place_3.png";
import placeImage4 from "../../../assets/images/winterGame/place/place_4.png";
import placeImage5 from "../../../assets/images/winterGame/place/place_5.png";
import placeImage6 from "../../../assets/images/winterGame/place/place_6.png";
import placeImage7 from "../../../assets/images/winterGame/place/place_7.png";
import placeImage8 from "../../../assets/images/winterGame/place/place_8.png";

export default {
  name: "honorRollModule",
  components: {
    shareBtn,
    normalModule,
  },
  props: {
    numbers: {
      type: String | Number,
      default: "",
    },
    honorData: {
      type: Object,
      default: {},
    },
    honorRollConfig: {
      type: Object,
      default: () => ({}),
    },
    homeConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      placeMap: null,
    };
  },
  computed: {
    memberPlace() {
      let index = 3;
      return this.placeMap.get(index);
      return {
        place: 1,
        placeName: "朝气白银",
        img: placeImage1,
      };
    },
  },
  created() {
    // 热血黑铁、朝气白银、无畏黄金、耀世铂金、璀璨钻石、超凡王者
    this.placeMap = new Map([
      [
        1,
        {
          place: 1,
          name: "热血黑铁",
          img: placeImage1,
        },
      ],
      [
        2,
        {
          place: 2,
          name: "朝气白银",
          img: placeImage2,
        },
      ],
      [
        3,
        {
          place: 3,
          name: "无畏黄金",
          img: placeImage3,
        },
      ],
      [
        4,
        {
          place: 4,
          name: "耀世铂金",
          img: placeImage4,
        },
      ],
      [
        5,
        {
          place: 5,
          name: "璀璨钻石",
          img: placeImage5,
        },
      ],
      [
        6,
        {
          place: 6,
          name: "超凡王者",
          img: placeImage6,
        },
      ],
      [
        7,
        {
          place: 7,
          name: "至尊王者",
          img: placeImage7,
        },
      ],
      [
        8,
        {
          place: 8,
          name: "傲世王者",
          img: placeImage8,
        },
      ],
    ]);
  },
  methods: {
    shareClick() {
      this.$emit("shareClick", this.honorData);
    },
    getPlaceClass(segment_icon) {
      if (segment_icon.indexOf(".png") > -1) {
        const lvIndex = segment_icon.lastIndexOf("/");
        const lv = segment_icon.substring(lvIndex + 1, segment_icon.length - 4);
        return lv;
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.honorRollModule {
  height: 288px;
  background: #ffffff;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  display: flex;

  aside {
    width: 240px;
    margin-left: 40px;
    display: flex;
    padding: 0 12px;
    background: linear-gradient(
      180deg,
      rgba(51, 67, 177, 1) 0%,
      rgba(69, 134, 231, 1) 100%
    );
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    position: relative;

    div {
      &:last-child,
      &:first-child {
        width: 8px;
        height: 288px;
        background: linear-gradient(180deg, #646dfb 0%, #12a5f6 100%);
      }

      &:nth-child(2) {
        position: relative;
        width: 200px;

        img {
          position: absolute;
          top: 30px;
          width: 100%;
          transform: scale(1.4);

          &.segment_id42,
          &.segment_id43,
          &.segment_id44 {
            transform: scale(1.1);
          }

          &.segment_id37,
          &.segment_id38,
          &.segment_id39,
          &.segment_id40,
          &.segment_id41 {
            transform: scale(1.2);
          }

          &.segment_id33,
          &.segment_id34,
          &.segment_id35,
          &.segment_id36 {
            transform: scale(1.2);
          }
        }

        span {
          position: absolute;
          bottom: 25px;
          width: 100%;
          text-align: center;
          color: #ffffff;
        }

        label {
          position: absolute;
          top: 123px;
          width: 12px;
          height: 28px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 28px;
          left: calc(50% - 5px);
        }
      }
    }
  }

  main {
    overflow: hidden;
    flex-grow: 1;
    position: relative;

    > div {
      position: absolute;
      top: 24px;
      right: -20px;
    }

    dl {
      margin-top: 120px;
      margin-bottom: 50px;
      text-align: center;

      dt {
        height: 56px;
        font-size: 40px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #323232;
        line-height: 56px;
        margin-bottom: 16px;
      }

      dd {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #68707d;
        line-height: 40px;
        margin: 0;
      }
    }
  }

  .lv_silver,
  .lv_gold {
    label {
      top: 126px !important;
    }
  }

  .lv_platinum {
    label {
      top: 122px !important;
    }
  }
}
</style>

<style lang="less">
.honorRollModule {
  aside {
    div {
      &:last-child,
      &:first-child {
        width: 8px;
        height: 288px;
      }
    }
  }
}
</style>
